module.exports = __webpack_public_path__ + "static/media/pizza-hut.5606b50e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/clients/pizza-hut.png
// module id = 259
// module chunks = 0